module.exports = __webpack_public_path__ + "static/Flow-60ab0148be3040e24f4c90c47edb3b9b.png";